const ProductListQuery = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0',
    formData:{},
    formField:[
        {
            // name:'product.inventoryCode', // 物料编码
            key:'inventory_code',
            type:'select',   
            allowClear:true,
            width:'200px',
            placeholder:'product.inventoryCode',
            options:[],
        },
        {
            // name:'product.sku',//SKU
            key:'sku',
            type:'select',   
            allowClear:true,
            width:'200px',
            placeholder:'product.sku',
            options:[],
        },
        {
            // name:'product.sku',//产品名称
            key:'english_name',
            type:'select',   
            allowClear:true,
            width:'200px',
            placeholder:'order.productName',
            options:[],
        },
        {
            // name:'product.torque',// 扭矩
            key:'torque',
            type:'select',   
            allowClear:true,
            width:'110px',
            placeholder:'product.torque',
            options:[
                {
                    label:'80 NM',
                    value:'80',
                },
                {
                    label:'90 NM',
                    value:'90',
                },
                {
                    label:'100 NM',
                    value:'100',
                }
            ]
        },
        {
            // name:'product.sku',//上市年份
            key:'model_year',
            type:'select',   
            allowClear:true,
            width:'120px',
            placeholder:'order.modelYear',
            optionToLocale:true,
            options:[
                {
                    label:'MY23',
                    value:'MY23'
                },
                {
                    label:'MY24',
                    value:'MY24'
                },
                {
                    label:'MY25',
                    value:'MY25'
                },
                {
                    label:'MY26',
                    value:'MY26'
                }
            ],
        },
        // {
        //     name:'product.warehouse',// 仓库
        //     key:'warehouse',
        //     type:'select',   
        //     allowClear:true,
        //     width:'420px',
        //     placeholder:'base.select',
        //     options:[]
        // },
        {
            // name:'product.brandName',// 品牌
            key:'brand_name',
            type:'select',   
            allowClear:true,
            width:'180px',
            placeholder:'product.brandName',
            options:[]
        },
        {
            // name:'product.partName',// 零件
            key:'part_name',
            type:'select',   
            allowClear:true,
            width:'180px',
            placeholder:'product.partName',
            options:[]
        },
        {
            // name:'order.customerType', // 物料类别
            key:'category_code',
            type:'select',
            allowClear:true,
            width:'200px',
            placeholder:'stock.categoryType',
            options:[]
        },
        {
            // name:'order.customerType', // 库存激活状态
            key:'inventory_item_status_code',
            type:'select',
            allowClear:true,
            width:'200px',
            placeholder:'product.activeStatus',
            optionToLocale:true,
            options:[
                {
                    label:'product.active',
                    value:'Active'
                },
                {
                    label:'product.inActive',
                    value:'InActive'
                }
            ]
        },
        // {
        //     // name:'order.customerType', // 是否可用
        //     key:'inventory_item_status_code',
        //     type:'select',
        //     allowClear:true,
        //     width:'180px',
        //     placeholder:'stock.categoryType',
        //     options:[
        //         {
        //             label:'Active',
        //             value:'Active',
        //         },
        //         {
        //             label:'Inactive',
        //             value:'Inactive',
        //         }
        //     ]
        // },
    ]
}

const AddForm = {
    labelColProps: { span: 6 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    formData:{},
    formField:[
        {
            name:'product.sku',//SKU
            key:'sku',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'product.inventoryCode', // 物料编码
            key:'inventory_code',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
            helpMsg:'',
            validateStatus:''
        },
        {
            name:'product.chineseName',// 产品名称(中文)
            key:'chinese_name',
            type:'input',   
            allowClear:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'product.englishName',// 产品名称(英文)
            key:'english_name',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'product.germanName',// 产品名称(德文)
            key:'german_name',
            type:'input',   
            allowClear:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'product.franceName',// 产品名称(法文)
            key:'france_name',
            type:'input',   
            allowClear:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'product.torque',// 扭矩
            key:'torque',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'product.frame',// 车架
            key:'frame',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
    ]
}

const ProductQuery = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0',
    formData:{},
    formField:[
        // {
        //     // name:'product.sku',//车型
        //     key:'model',
        //     type:'select',
        //     width:'230px',
        //     placeholder:'product.model',
        //     optionToLocale:true,
        //     options:[
        //         {
        //             label:'product.trekking7',
        //             value:'1'
        //         },
        //         {
        //             label:'product.mountain7',
        //             value:'2'
        //         },
        //         {
        //             label:'product.trekking7Carbon',
        //             value:'3'
        //         },
        //         // {
        //         //     label:'product.trekking7MY23',
        //         //     value:'4'
        //         // }
        //     ],
        // },
        // {
        //     // name:'product.sku',//SKU
        //     key:'sku',
        //     type:'select',   
        //     allowClear:true,
        //     width:'230px',
        //     placeholder:'product.sku',
        //     options:[],
        // },
        // {
        //     // name:'product.sku',//上市年份
        //     key:'model_year',
        //     type:'select',   
        //     allowClear:true,
        //     width:'230px',
        //     placeholder:'product.modelYear',
        //     optionToLocale:true,
        //     options:[
        //         {
        //             label:'2023',
        //             value:'MY23'
        //         },
        //         {   
        //             label:'2024',
        //             value:'MY24'
        //         }
        //     ],
        // },
        {
            // name:'product.sku',// 仓库
            key:'warehouse',
            type:'select',   
            allowClear:true,
            multiple:true,
            width:'530px',
            placeholder:'product.warehouse',
            options:[],
        },
    ]
}

ProductListQuery.formField.forEach(item=>{
    ProductListQuery.formData[item.key] = ''
})

AddForm.formField.forEach(item=>{
    AddForm.formData[item.key] = ''
})

ProductQuery.formField.forEach(item=>{
    if(item.key == 'warehouse') ProductQuery.formData[item.key] = []
    else ProductQuery.formData[item.key] = ''
})

export {
    ProductListQuery,
    AddForm,
    ProductQuery
}